import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, GFunc, LocaleX, QsX, ReqX, ZArray } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, Spacer, VStack, XButton, XText } from "IZOX/_X";
import PAContainer from "../shared/PAContainer/PAContainer";
import { PageFlipper, QForm } from "IZOX/BLOCKS/Libs";
import { QFCheckBox, QFDate, QFDropdown, QFText } from "IZOX/BLOCKS/Libs/QForm/_gears";
import _ from "lodash";
import NewPolicy from "./_gears/NewPolicy";
import QUICKUI from "shared/QUICKUI";
import ViewPolicy from "./_gears/ViewPolicy";
import PolicyRow from "shared/PolicyRow";
import UploadDocs from "./_gears/UploadDocs";
import { withRouter } from "react-router-dom/cjs/react-router-dom";
import VarList from "shared/VarList";
import RenewPolicy from "./_gears/RenewPolicy";
import fileDownload from "js-file-download";

/**
 * @augments {Component<Props, State>}
 */
class PAAllPoliciesW extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {
      docs: [],
      selected: [],
      tab: "Total",
      page: 0,
      pageSize: 5,
      search: false,
      searchForm: {}
    };
  }

  componentDidMount(){
    this._setAllStates(() => {
      this.GetNationalityList();
      let res = this.ParseQS();
      if(res){
        this.GetPolicies();
      }
    });
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PAAllPoliciesW.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  ParseQS = () => {
    let {location} = this.props;
    let {search} = location ?? {};
    let params = QsX.Parse(search);
    let {status} = params ?? {};
    if(status){
      this._toTab(status);
      return false;
    }
    return true;
    
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  GetNationalityList = async () => {
    let docs = await VarList.GetList("Nationality");
    this.setState({
      nationalities: docs
    });
  }

  _Reload = () => {
    let {search} = this.state;
    if(search){
      this._toSearch();
    }else{
      this.GetPolicies();
    }
  }

  _onUpload = (_id) => {
    this._toUpload([_id]);
  }

  _onDownload = async (policyID) => {
    let res = await ReqX.SendBEAndGetBlob("/Web/Agent/GenerateReport", {
      policyID
    });
    let { Success, blob } = res;
    if (Success) {
      const getBlob = new Blob([blob], { type: "application/zip" });
      fileDownload(getBlob, "reports.zip");
    }
  }

  _onCheck = (_id) => {
    let {selected, docs} = this.state;
    if(selected.includes(_id)){
      selected = _.filter(selected, o => o !== _id);
    }else{
      selected.push(_id);
    }

    let selectedAllForm = {
      selectAll: false
    };
    if(selected.length === docs.length){
      selectedAllForm = {
        selectAll: true
      };
    }
    this.setState({
      selected: selected,
      selectedAllForm: selectedAllForm
    });
  }

  GetPolicies = async () => {
    let {tab, page, pageSize} = this.state;
    let res = await ReqX.SendBE("/Web/Agent/GetPolicies", {
      status: tab === "Total" ? undefined : tab,
      page: page,
      pageSize: pageSize
    });
    let {Success, payload} = res;
    if(Success){
      let {docs, count} = payload;
      this.setState({
        docs: docs,
        count: count
      });
    }
  }

  _onPageSizeChange = (pageSize) => {
    this.setState({
      pageSize: pageSize
    }, () => {
      this._Reload();
    });
  }

  _onPageChange = (page) => {
    this.setState({
      page: page
    }, () => {
      this._Reload();
    });
  }

  onMountQForm = (callbacks) => {
    this.MountQForm = callbacks;
  }

  onFormChange = (formValue) => {
    this.setState({
      searchForm: formValue
    });
  }

  _toNewPolicy = () => {
    GFunc.Backdrop(() => {
      return (
        <NewPolicy refreshFunc={this._Reload}/>
      );
    }, {}, false);
  }

  _toClearSearch = () => {
    this.setState({
      searchForm: {},
      search: false
    }, () => {
      this.MountQForm?.Clear();
      this._Reload();
    });
  }

  _toSearch = () => {
    this.setState({
      page: 0
    }, () => {
      this._toSearchSubmit();
    });
  }

  _toSearchSubmit = async () => {
    let {tab, page, pageSize, searchForm} = this.state;
    let res = await ReqX.SendBE("/Web/Agent/SearchPolicies", {
      searchForm, 
      status: tab === "Total" ? undefined : tab,
      page, pageSize
    });
    let {Success, payload} = res;
    if(Success){
      let {docs, count} = payload;
      this.setState({
        docs: docs,
        count: count,
        search: true
      });
    }
  }

  _toUpload = (selected, isReceipt = false) => {
    GFunc.Backdrop(() => {
      return (
        <UploadDocs selected={selected} isReceipt={isReceipt}/>
      );
    }, {}, false);
  }

  _toReceipt = (selected) => {
    this._toUpload(selected, true);
  }

  _toRenew = (selected) => {
    selected = ZArray.Ensure(selected);
    GFunc.Backdrop(() => {
      return (
        <RenewPolicy selected={selected}/>
      );
    }, {}, false);
  }

  _toToggleCheckAll = (selectedAllForm) => {
    let {docs} = this.state;
    let {selectAll} = selectedAllForm;
    let _selected = selectAll ? _.map(docs, o => o._id) : [];
    this.setState({
      selected: _selected,
      selectedAllForm: selectedAllForm
    });
  }

  _toTab = (tab) => {
    console.log(tab);
    this.setState({
      tab: tab,
      page: 0,
      selected: [],
      selectedAllForm: {
        selectAll: false
      }
    }, () => {
      this.GetPolicies();
    });
  }

  _toPopupDetails = async (_id) => {
    GFunc.Backdrop(() => {
      return (
        <ViewPolicy docID={_id}/>
      );
    }, {}, false);
  }

  renderHeader(){
    return (
      <HStack mB={24}>
        <XText bold color={ColorX.CSS("Leaf")} fontSize={16}>
          {LocaleX.Parse({
            EN: "All Policies",
            TC: "所有保單"
          })}
        </XText>
        <Spacer/>
        <XButton onPress={this._toNewPolicy} pH={30} round={50}
            bgColor={ColorX.CSS("Axit")}
            color={ColorX.CSS("pureWhite")}
            padding={6}>
          <HStack>
            <XText bold fontSize={14}>
              {LocaleX.Parse({
                EN: "Add new policy",
                TC: "新增保單"
              })}
            </XText>
          </HStack>
        </XButton>
      </HStack>
    );
  }

  renderTextField(name, label, readOnly = false){
    let {userDoc} = this.state;
    let value = Accessor.Get(userDoc, name);
    return (
      <VStack fullWidth>
        <HStack HAlign="[" spacing={4}>
          <XText fontSize={12} color={ColorX.CSS("Stone")}>
            {LocaleX.Parse(label)}
          </XText>
        </HStack>
        <QFText name={name} placeholder={LocaleX.Parse({
          EN: "Search ",
          TC: "搜尋 "
        }) + LocaleX.Parse(label).toLowerCase()} disabled={readOnly}
          defaultValue={value}
          p={12}
          focus_bColor={ColorX.CSS("Axit")}
          bColor={ColorX.CSS("Gray5")}/>
      </VStack>
    );
  }

  renderSearchForm(){
    let {search, searchForm, nationalities} = this.state;
    return (
      <QForm fullWidth p={16} bgColor={ColorX.CSS("pureWhite")}
        value={searchForm} onMounted={this.onMountQForm}
        spacing={24} onChange={this.onFormChange}>
        <HStack spacing={24}>
          {this.renderTextField("customerName", 
            {
              EN: "Customer's name",
              TC: "顧客名稱"
            })}
          {this.renderTextField("helperName", 
          {
            EN: "Helper's name",
            TC: "助理名稱"
          })}
        </HStack>
        <HStack spacing={24}>
          {this.renderTextField("policyNo", 
            {
              EN: "Policy number / Insurance certificate No.",
              TC: "保單號碼 / 保險憑證號碼"
            })}
          {this.renderTextField("helperPassport", 
          {
            EN: "Helper's passport number / ID",
            TC: "助理的護照號碼 / 身分證號碼"
          })}
        </HStack>
        <HStack spacing={24} mB={24}>
          <VStack fullWidth>
            <HStack HAlign="[" spacing={4}>
              <XText fontSize={12} color={ColorX.CSS("Stone")}>
                {LocaleX.Parse({
                  EN: "Nationality",
                  TC: "國籍"
                })}
              </XText>
            </HStack>
            <QFDropdown name={"nationality"}
              options={nationalities}
              placeholder={LocaleX.Parse({
                EN: "Select Nationality",
                TC: "選擇國籍"
              })}
              valAccessor="_id"
              capAccessor="name"
              p={12}
              bW={1}
              height={44}
              focus_bColor={ColorX.CSS("Axit")}
              bColor={ColorX.CSS("Gray5")}
              allowSearch/>
          </VStack>
          <VStack fullWidth>
            <HStack HAlign="[" spacing={4}>
              <XText fontSize={12} color={ColorX.CSS("Stone")}>
                {LocaleX.Parse({
                  EN: "Effective date",
                  TC: "有效日期"
                })}
              </XText>
            </HStack>
            <QFDate name={"startAt"}
              p={12}
              bW={1}
              height={44}
              focus_bColor={ColorX.CSS("Axit")}
              bColor={ColorX.CSS("Gray5")}
              placeholder={LocaleX.Parse({
                EN: "Search effective date",
                TC: "搜尋有效日期"
              })}/>
          </VStack>
        </HStack>
        <HStack>
          <XButton onPress={this._toClearSearch} fullWidth
            color={ColorX.CSS("Axit")}>
            <HStack>
              <XText bold>
                {LocaleX.Parse({
                  EN: "Reset",
                  TC: "重置"
                })}
              </XText>
            </HStack>
          </XButton>
          <XButton onPress={this._toSearch} padding={0} pV={5} fullWidth
            color={ColorX.CSS(search ? "pureWhite" : "Axit")} 
            bgColor={ColorX.CSS(search ? "Axit" : "pureWhite")} 
            style={{borderColor: ColorX.CSS("Axit")}}
            bW={1} round={50}>
            <HStack>
              <XText bold>
                {LocaleX.Parse({
                  EN: "Search",
                  TC: "搜尋"
                })}
              </XText>
            </HStack>
          </XButton>
        </HStack>
      </QForm>
    );
  }

  renderBulkBtn(label, func){
    let {selected} = this.state;
    return (
    <XButton onPress={func} fitWidthToContent padding={8}
      disabled={!selected || selected?.length === 0}
        pH={15} round={50} bW={1}
        bColor={ColorX.CSS("Axit")}
        color={ColorX.CSS("Axit")}>
        <HStack>
          <XText fontSize={12}>
            {LocaleX.Parse({
              EN: `${label?.EN ?? label} (${selected?.length})`,
              TC: `${label?.TC ?? label} (${selected?.length})`
            })}
          </XText>
        </HStack>
      </XButton>
    );
  }

  renderPolicyHeader(){
    let {selected, tab, count} = this.state;
    return (
      <HStack spacing={20}>
        <XText bold>
          {LocaleX.Parse({
            EN: `List policies (${count ?? 0})`,
            TC: `保單清單 (${count ?? 0})`
          })}
        </XText>
        <Spacer/>
        {this.renderBulkBtn({
          EN: "Upload documents",
          TC: "上傳文件"
        }, () => this._toUpload(selected))}
        {this.renderBulkBtn({
          EN: "Upload receipts",
          TC: "上傳收據"
        }, () => this._toUpload(selected, true))}
        {tab === "ExpirySoon" &&
          this.renderBulkBtn({
            EN: "Batch Renew",
            TC: "批量續訂"
          }, () => this._toRenew(selected))}
      </HStack>
    );
  }

  renderTabBtn(_tab, text, extraStyle, idx){
    let {tab} = this.state;
    let isTab = tab === _tab;
    return (
      <XButton color={ColorX.CSS(isTab? "pureWhite" : "Gray4")}
        bgColor={ColorX.CSS(isTab ? "Axit" : "pureWhite")}
        fitWidthToContent zIndex={isTab ? 15 : 10 - idx}
        mL={idx === 0 ? 0 : -10} mT={10}
        padding={10} pH={15}
        onPress={() => this._toTab(_tab)}
        style={{
          ...extraStyle,
          minWidth: 50,
          borderRadius: "10px 10px 0px 0px",
          boxShadow: `0px 2px 2px 2px ${ColorX.CSS("greyOut", 0.5)}`
        }}>
        <HStack>
          <XText fontSize={14}>
            {LocaleX.Parse(text)}
          </XText>
        </HStack>
      </XButton>
    );
  }

  renderPolicyTabs(){
    let {selectedAllForm} = this.state;
    return (
      <HStack HAlign="[">
        {this.renderTabBtn("Total", {EN: "All", TC: "全部"}, {}, 0)}
        {this.renderTabBtn("AwaitingClientConfirmation", {EN: "Awaiting Client", TC: "等待客戶確認"}, {}, 1)}
        {this.renderTabBtn("Pending", {EN: "Pending", TC: "處理中"}, {}, 2)}
        {this.renderTabBtn("Active", {EN: "Active", TC: "生效中"}, {}, 3)}
        {this.renderTabBtn("ExpirySoon", {EN: "Expiry Soon", TC: "即將過期"}, {}, 4)}
        {this.renderTabBtn("Expired", {EN: "Expired", TC: "已過期"}, {}, 5)}
        {this.renderTabBtn("Canceled", {EN: "Canceled", TC: "已取消"}, {}, 6)}
        {this.renderTabBtn("Renewed", {EN: "Renewal", TC: "已更新"}, {}, 7)}
        <Spacer/>
        <QForm onChange={this._toToggleCheckAll} value={selectedAllForm}>
          <HStack spacing={10} fitWidthToContent>
            <QFCheckBox name="selectAll"
              bColor={ColorX.CSS("pureWhite")} size={16}
              bgColor={ColorX.CSS("pureWhite")} color={ColorX.CSS("Axit")} />
            <XText color={ColorX.CSS("Axit")}>
              {LocaleX.Parse({
                EN: "Check all",
                TC: "勾選全部"
              })}
            </XText>
          </HStack>
        </QForm>
      </HStack>
    );
  }

  renderVertBox(label, value, style, containerStyle){
    return (
      <VStack fitWidthToContent HAlign="[" mH={5} style={containerStyle}>
        <HStack HAlign="[" fitWidthToContent>
          <XText color={ColorX.CSS("Gray4")} fullWidth
            fontSize={12}>
            {LocaleX.Parse(label)}
          </XText>
        </HStack>
        <HStack HAlign="[" fitWidthToContent>
          <XText color={ColorX.CSS("Stone")} fontSize={13}
            style={style} fullWidth>
            {LocaleX.Parse(value)}
          </XText>
        </HStack>
      </VStack>
    );
  }

  renderPolicyDoc(doc, idx){
    let {selected, tab} = this.state;
    let {_id} = doc;
    let isRenew = tab === "ExpirySoon";

    return (
      <PolicyRow policyDoc={doc} key={idx} 
        checked={selected.includes(_id)}
        onCheck={() => this._onCheck(_id)}
        onDownload={() => this._onDownload(_id)}
        onUpload={() => this._onUpload(_id)}
        onReceipt={() => this._toReceipt(_id)}
        onViewDetailPress={() => this._toPopupDetails(_id)}
        onRenew={() => this._toRenew(_id)}
        isRenew={isRenew}/>
    );
  }

  renderPolicyList(){
    let {docs, page, pageSize, count} = this.state;
    if(docs.length === 0){
      return QUICKUI.NoDocs({
        EN: "There is no policies.",
        TC: "沒有任何保單。"
      });
    }
    
    return (
      <VStack fullWidth>
        {_.map(docs, (o, i) => {
          return this.renderPolicyDoc(o, i);
        })}
        <PageFlipper totalDocs={count} 
          page={page}
          pageSize={pageSize}
          onPageSizeChange={this._onPageSizeChange}
          onPageChange={this._onPageChange}
          popupPosition="top" 
          mainColor={ColorX.CSS("Axit")} />
      </VStack>
    );
  }

  renderPolicies(){
    return (
      <VStack fullWidth mT={20}>
        {this.renderPolicyHeader()}
        {this.renderPolicyTabs()}
        {this.renderPolicyList()}
      </VStack>
    );
  }

  render(){
    return (
      <PAContainer>
        <VStack bgColor={ColorX.CSS("NotQuiteWhite")} fullWidth
          p={16}>
          {this.renderHeader()}
          {this.renderSearchForm()}
          {this.renderPolicies()}
        </VStack>
      </PAContainer>
    );
  }

}

export default withRouter(observer(PAAllPoliciesW));
